import { Components } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import CropImageModalProps from "./CropImageModal";
import { FlexRowCenter } from "../../../../Common/Styles";

const ModalHeader = ({
  setIsCropModalOpen,
}: CropImageModalProps.ModalHeader) => {
  const { typography } = useTheme();
  return (
    <Container>
      <Components.Icon type="Image" size="24px" />
      <Components.Text
        style={{ tokenStyle: typography.Heading.M }}
        text={"Cover Image"}
        lineHeight="line-height-300"
      />
      <ButtonWrapper>
        <Components.IconButton
          disabled={false}
          iconType="X"
          kind="Tertiary"
          size="Medium"
          onClick={() => setIsCropModalOpen(false)}
        />
      </ButtonWrapper>
    </Container>
  );
};

export default ModalHeader;

const Container = styled(FlexRowCenter)`
  position: relative;
  gap: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-9"].value}rem
    ${({ theme }) => theme.spacing["spacing-5"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;

const ButtonWrapper = styled.div`
  position: absolute;
  top: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
  right: ${({ theme }) => theme.spacing["spacing-2"].value}rem;
`;
